<div class="tw-bg-[#F8F9FB] tw-min-h-screen">
    <app-dashboard-wrapper>
        <!-- Desktop and Tablet Only -->
        <div class="tw-hidden md:tw-block tw-p-[0.8rem]">
            <!-- Tabs -->
            <div class="tw-flex tw-space-x-4 tw-mb-6">
                <button
                    (click)="onTabChange('business')"
                    [ngClass]="{
                        'tw-bg-[#0A0A75] tw-text-white':
                            activeTab === 'business',
                        'tw-bg-[#0000001A] tw-text-[#00000066]':
                            activeTab !== 'business'
                    }"
                    class="tw-px-4 tw-py-2 tw-rounded-full tw-text-[16px] tw-font-bold"
                >
                    {{ "COMMON.BUSINESS_FINANCING_TITLE" | translate }}
                </button>

                <button
                    (click)="onTabChange('branch')"
                    [ngClass]="{
                        'tw-bg-[#0A0A75] tw-text-white': activeTab === 'branch',
                        'tw-bg-[#0000001A] tw-text-[#00000066]':
                            activeTab !== 'branch'
                    }"
                    class="tw-px-4 tw-py-2 tw-rounded-full tw-text-[16px] tw-font-bold"
                >
                    Branch Referral
                </button>

                <button
                    (click)="onTabChange('portfolio')"
                    [ngClass]="{
                        'tw-bg-[#0A0A75] tw-text-white':
                            activeTab === 'portfolio',
                        'tw-bg-[#0000001A] tw-text-[#00000066]':
                            activeTab !== 'portfolio'
                    }"
                    class="tw-px-4 tw-py-2 tw-rounded-full tw-text-[16px] tw-font-bold"
                >
                    Portfolio Guarantee Referral
                </button>
            </div>

            <!-- Approved Applications Title -->
            <h2
                *ngIf="approvedApplications?.length"
                class="tw-text-[18px] !tw-font-semibold tw-mb-4"
            >
                {{ "DASHBOARD.DASHBOARD_MAIN.APPROVED_APP" | translate }}
            </h2>

            <ng-conatiner *ngIf="apiResponse">
                <!-- No approved application -->
                <div
                    *ngIf="!approvedApplications?.length"
                    class="tw-flex tw-items-center tw-justify-between tw-mb-[22px]"
                >
                    <!-- Left side: title + status -->
                    <div class="tw-flex tw-flex-col">
                        <h2 class="tw-text-[18px] !tw-font-semibold">
                            {{
                                "DASHBOARD.DASHBOARD_MAIN.APPROVED_APP"
                                    | translate
                            }}
                        </h2>
                        <p class="tw-text-gray-500">
                            {{ "DASHBOARD.DASHBOARD_MAIN.NO_APP" | translate }}
                        </p>
                    </div>

                    <!-- Right side: button -->
                    <button
                        *ngIf="activeTab === 'business'"
                        class="tw-flex tw-items-center tw-gap-2 tw-bg-[#4B6EEC] tw-text-white tw-text-sm tw-font-semibold tw-rounded-xl tw-h-[56px] tw-px-6"
                        (click)="onSubmitNewApp()"
                    >
                        <mat-icon>add</mat-icon>
                        {{
                            "DASHBOARD.DASHBOARD_MAIN.SUBMIT_NEW_APP"
                                | translate
                        }}
                    </button>
                </div>

                <!-- Cards Grid -->
                <div
                    *ngIf="approvedApplications?.length"
                    class="tw-grid md:tw-grid-cols-2 lg:tw-grid-cols-3 xl:tw-grid-cols-4 tw-gap-[0.7rem] !tw-mb-10"
                >
                    <ng-container
                        *ngFor="
                            let item of approvedApplications
                                | slice : 0 : visibleCardsCount
                        "
                    >
                        <div
                            class="tw-justify-between tw-bg-white tw-rounded-xl tw-shadow-sm tw-border tw-border-gray-200 tw-flex tw-flex-col tw-overflow-hidden"
                        >
                            <!-- Content Section -->
                            <div
                                class="tw-p-5 tw-relative tw-pb-[55px] tw-h-full"
                            >
                                <p class="tw-text-xs tw-text-gray-500">
                                    {{ item.updatedDateTime }}
                                </p>
                                <!-- Logo and Title -->
                                <div
                                    class="tw-flex tw-items-start tw-gap-4 tw-mt-2 tw-mb-4"
                                >
                                    <div
                                        class="tw-flex tw-items-center tw-justify-center tw-w-[58px] tw-h-[58px] tw-object-contain tw-rounded-full tw-border tw-p-2 tw-shrink-0"
                                    >
                                        <img
                                            [src]="item.prodImage"
                                            alt="Bank Logo"
                                            class="tw-w-full"
                                        />
                                    </div>
                                    <div>
                                        <p
                                            class="!tw-text-[11px] tw-text-[#7B7575] !tw-font-semibold !tw-mb-1"
                                        >
                                            {{ item.cCaseAppNo }}
                                        </p>
                                        <p
                                            class="tw-text-sm tw-font-bold tw-text-black !tw-h-[96px]"
                                        >
                                            {{ item.productName }}
                                        </p>
                                    </div>
                                </div>

                                <!-- Info Grid -->
                                <div
                                    class="tw-grid tw-grid-cols-2 tw-gap-[10px] tw-text-[13px]"
                                >
                                    <!-- Row 1: Financing + Processing -->
                                    <div>
                                        <div
                                            class="tw-bg-gray-100 tw-text-gray-500 tw-text-[11px] tw-font-medium tw-px-2 tw-py-1"
                                        >
                                            {{ "COMMON.FINANCING" | translate }}
                                        </div>
                                        <div
                                            class="tw-mt-1 tw-text-sm tw-font-bold tw-text-black tw-min-h-[40px]"
                                        >
                                            {{
                                                item.productValidation
                                                    ?.financeAmount?.min
                                                    | currency
                                                        : "RM "
                                                        : "symbol"
                                                        : "1.0-0"
                                            }}
                                            - <br />
                                            {{
                                                item.productValidation
                                                    ?.financeAmount?.max
                                                    | currency
                                                        : "RM "
                                                        : "symbol"
                                                        : "1.0-0"
                                            }}
                                        </div>
                                        <div
                                            class="tw-text-[12px] tw-font-medium tw-text-gray-500"
                                        >
                                            {{ "STARTS_FROM" | translate }}
                                        </div>
                                    </div>
                                    <div>
                                        <div
                                            class="tw-bg-gray-100 tw-text-gray-500 tw-text-[11px] tw-font-medium tw-px-2 tw-py-1"
                                        >
                                            {{
                                                "NEW_PRODUCTS.PROCESSING"
                                                    | translate
                                            }}
                                        </div>
                                        <div
                                            class="tw-mt-1 tw-text-sm tw-font-bold tw-text-black"
                                        >
                                            {{ item.prodTat }}
                                            {{ "WORKING_DAYS" | translate }}
                                        </div>
                                    </div>

                                    <!-- Row 2: Tenure + Interest -->
                                    <div>
                                        <div
                                            class="tw-bg-gray-100 tw-text-gray-500 tw-text-[11px] tw-font-medium tw-px-2 tw-py-1"
                                        >
                                            {{ "COMMON.TENURE" | translate }}
                                        </div>
                                        <div
                                            class="tw-mt-1 tw-text-sm tw-font-bold tw-text-black"
                                        >
                                            {{
                                                item?.productValidation?.tenure
                                                    ?.max
                                            }}
                                            <span>
                                                {{
                                                    item?.productValidation
                                                        ?.tenure?.unit
                                                        | uppercase
                                                        | translate
                                                }}
                                            </span>
                                        </div>
                                    </div>
                                    <div>
                                        <div
                                            class="tw-bg-gray-100 tw-text-gray-500 tw-text-[11px] tw-font-medium tw-px-2 tw-py-1"
                                        >
                                            {{ "COMMON.INTEREST" | translate }}
                                        </div>
                                        <div
                                            class="tw-mt-1 tw-text-sm tw-font-bold tw-text-black"
                                        >
                                            {{ item.prodAvgIr }} %
                                        </div>
                                    </div>
                                </div>

                                <div
                                    class="tw-mt-5 tw-text-center tw-absolute tw-left-0 tw-bottom-[10px] tw-w-full"
                                >
                                    <button
                                        class="tw-border tw-border-[#003A70] tw-text-[#003A70] tw-text-xs tw-font-semibold tw-rounded-full tw-px-[26px] tw-py-[10px]"
                                        (click)="viewAppDetails(item)"
                                    >
                                        {{ "COMMON.VIEW_DETAILS" | translate }}
                                    </button>
                                </div>
                            </div>

                            <!-- Status Footer -->
                            <div
                                class="tw-bg-[#00940224] tw-text-center tw-p-3"
                            >
                                <p
                                    class="tw-text-[#7B7575] tw-text-sm tw-font-medium !tw-mb-1"
                                >
                                    {{ "COMMON.STATUS" | translate }}
                                </p>
                                <p
                                    class="tw-text-[#009402] tw-text-sm tw-font-semibold tw-flex tw-items-center tw-justify-center tw-gap-1"
                                >
                                    <mat-icon class="tw-min-w-[32px]"
                                        >check_circle_outline</mat-icon
                                    >
                                    <span>
                                        {{ item.cCaseStatus | translate }}
                                    </span>
                                </p>
                            </div>
                        </div>
                    </ng-container>
                </div>

                <div
                    class="tw-flex tw-justify-center tw-mb-10"
                    *ngIf="
                        approvedApplications.length > initialCardCount &&
                        visibleCardsCount < approvedApplications.length
                    "
                >
                    <button
                        class="tw-bg-[#DFE0E266] tw-text-[#8D8D8D] tw-text-base tw-font-semibold tw-rounded-[10px] tw-py-[10px] tw-px-[26px] tw-w-[292px] tw-h-[43px] tw-flex tw-items-center tw-justify-center tw-gap-1"
                        (click)="onShowMore()"
                    >
                        {{ "SELECT_BRANCH.SHOW_MORE" | translate }}
                        <mat-icon>expand_more</mat-icon>
                    </button>
                </div>

                <!--Table Tabs -->
                <div class="tw-flex tw-space-x-8 tw-mb-3">
                    <button
                        class="tw-relative tw-pb-2 tw-text-[16px] tw-font-semibold"
                        [ngClass]="{
                            'tw-text-black': activeTableTab === 'recent',
                            'tw-text-gray-500': activeTableTab !== 'recent'
                        }"
                        (click)="onTableTabChange('recent')"
                    >
                        {{ "COMMON.RECENT" | translate }}
                        <span
                            *ngIf="activeTableTab === 'recent'"
                            class="tw-absolute tw-bottom-0 tw-left-0 tw-w-full tw-h-[2px] tw-bg-black"
                        ></span>
                    </button>

                    <button
                        *ngIf="activeTab === 'business'"
                        class="tw-relative tw-pb-2 tw-text-[16px] tw-font-semibold"
                        [ngClass]="{
                            'tw-text-black': activeTableTab === 'past',
                            'tw-text-gray-500': activeTableTab !== 'past'
                        }"
                        (click)="onTableTabChange('past')"
                    >
                        {{ "COMMON.PAST" | translate }}
                        <span
                            *ngIf="activeTableTab === 'past'"
                            class="tw-absolute tw-bottom-0 tw-left-0 tw-w-full tw-h-[2px] tw-bg-black"
                        ></span>
                    </button>

                    <button
                        *ngIf="activeTab === 'business'"
                        class="tw-relative tw-pb-2 tw-text-[16px] tw-font-semibold"
                        [ngClass]="{
                            'tw-text-black': activeTableTab === 'draft',
                            'tw-text-gray-500': activeTableTab !== 'draft'
                        }"
                        (click)="onTableTabChange('draft')"
                    >
                        {{ "COMMON.DRAFT" | translate }}
                        <span
                            *ngIf="activeTableTab === 'draft'"
                            class="tw-absolute tw-bottom-0 tw-left-0 tw-w-full tw-h-[2px] tw-bg-black"
                        ></span>
                    </button>
                </div>

                <ng-container *ngIf="activeTableTab === 'recent'">
                    <ng-container *ngIf="paginatedData.length > 0; else noData">
                        <app-all-applications-recent
                            [paginatedApplications]="paginatedData"
                            (viewDetailsClicked)="viewAppDetails($event)"
                        >
                        </app-all-applications-recent>
                    </ng-container>
                </ng-container>
                <ng-container *ngIf="activeTableTab === 'past'">
                    <ng-container *ngIf="isPastAppLoading; else pastAppLoaded">
                        <app-loader [showLoader]="true"></app-loader>
                    </ng-container>
                    <ng-template #pastAppLoaded>
                        <ng-container
                            *ngIf="paginatedData.length > 0; else noData"
                        >
                            <app-all-applications-past
                                [pastApplications]="paginatedData"
                                (viewDetailsClicked)="viewAppDetails($event)"
                            >
                            </app-all-applications-past>
                        </ng-container>
                    </ng-template>
                </ng-container>
                <ng-container *ngIf="activeTableTab === 'draft'">
                    <app-all-applications-draft></app-all-applications-draft>
                </ng-container>

                <!-- Pagination (Desktop/Tablet) -->
                <ng-container
                    *ngIf="
                        (activeTableTab === 'recent' ||
                            activeTableTab === 'past') &&
                        paginatedData.length > 0
                    "
                >
                    <div class="tw-flex tw-justify-end tw-mt-6">
                        <div
                            class="tw-flex tw-border tw-border-[#D1D5DB] tw-rounded-md tw-overflow-hidden tw-select-none"
                        >
                            <!-- Previous -->
                            <button
                                class="tw-flex tw-items-center tw-justify-center tw-gap-1 tw-w-[120px] tw-h-[34px] tw-border-r tw-border-[#D1D5DB] tw-font-medium tw-text-[14px]"
                                [disabled]="currentPage === 1"
                                (click)="goToPreviousPage()"
                            >
                                <mat-icon
                                    class="tw-text-[16px] !tw-h-[16px]"
                                    style="color: rgba(52, 51, 48, 0.5)"
                                    >arrow_back</mat-icon
                                >
                                {{
                                    "DASHBOARD.DASHBOARD_MAIN.PREVIOUS"
                                        | translate
                                }}
                            </button>

                            <!-- Page Numbers -->
                            <ng-container *ngFor="let page of pagesToShow">
                                <button
                                    *ngIf="page !== '...'; else dotsTpl"
                                    (click)="goToPage(page)"
                                    [ngClass]="{
                                        'tw-bg-[#003A70] tw-text-white':
                                            currentPage === page,
                                        'tw-bg-white tw-text-[#343330] hover:tw-bg-gray-100':
                                            currentPage !== page
                                    }"
                                    class="tw-w-[34px] tw-h-[34px] tw-font-medium tw-text-[14px]"
                                >
                                    {{ page }}
                                </button>
                                <ng-template #dotsTpl>
                                    <button
                                        class="tw-w-[34px] tw-h-[34px] tw-font-medium tw-text-[14px] tw-text-gray-400"
                                        disabled
                                    >
                                        ...
                                    </button>
                                </ng-template>
                            </ng-container>

                            <!-- Next -->
                            <button
                                class="tw-flex tw-items-center tw-justify-center tw-gap-1 tw-w-[120px] tw-h-[34px] tw-rounded-[20px] tw-font-medium tw-text-[14px]"
                                [disabled]="currentPage === totalPages"
                                (click)="goToNextPage()"
                            >
                                {{
                                    "DASHBOARD.DASHBOARD_MAIN.NEXT" | translate
                                }}
                                <mat-icon
                                    class="tw-text-[16px] !tw-h-[16px]"
                                    style="color: rgba(52, 51, 48, 0.5)"
                                    >arrow_forward</mat-icon
                                >
                            </button>
                        </div>
                    </div>
                </ng-container>

                <ng-template #noData>
                    <p class="!tw-mt-9">
                        {{ "DASHBOARD.DASHBOARD_MAIN.NO_APP" | translate }}
                    </p>
                </ng-template>
            </ng-conatiner>
        </div>

        <!-- Mobile Design -->
        <div class="tw-block md:tw-hidden tw-py-4">
            <!--Applications -->
            <h2 class="tw-text-[22px] tw-font-semibold tw-mb-3">
                {{ "COMMON.APPLICATION_RECENT" | translate }}
            </h2>

            <!-- Tabs Dropdown -->
            <div class="tw-mb-4 tw-relative tw-inline-block">
                <select
                    [value]="activeTab"
                    (change)="onTabChange($event.target.value)"
                    class="tw-w-[217px] tw-border tw-border-[#0A0A75] tw-rounded-[10px] tw-py-2 tw-pl-3 tw-pr-8 tw-text-xs tw-font-semibold focus:tw-ring-2 focus:tw-ring-[#0A0A75] tw-appearance-none tw-bg-white tw-text-[#0A0A75]"
                >
                    <option value="business">
                        {{ "COMMON.BUSINESS_FINANCING_TITLE" | translate }}
                    </option>
                    <option value="branch">Branch Referral</option>
                    <option value="portfolio">
                        Portfolio Guarantee Referral
                    </option>
                </select>

                <!-- Custom arrow -->
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="tw-pointer-events-none tw-absolute tw-right-3 tw-top-1/2 -tw-translate-y-1/2"
                    width="12"
                    height="7.4"
                    viewBox="0 0 12 7.4"
                    fill="none"
                >
                    <path
                        d="M1 1L6 6L11 1"
                        stroke="#0A0A75"
                        stroke-width="1.5"
                        stroke-linecap="round"
                    />
                </svg>
            </div>

            <!-- Approved Applications -->
            <h2 class="tw-text-base tw-font-semibold tw-mb-3">
                {{ "DASHBOARD.DASHBOARD_MAIN.APPROVED_APP" | translate }}
            </h2>

            <!-- No Application Section -->
            <div
                *ngIf="apiResponse && !approvedApplications?.length"
                class="tw-flex tw-flex-col tw-gap-3"
            >
                <p class="tw-text-gray-500 tw-text-sm">
                    {{ "DASHBOARD.DASHBOARD_MAIN.NO_APP" | translate }}
                </p>
                <button
                    *ngIf="activeTab === 'business'"
                    class="tw-flex tw-flex-row tw-items-center tw-justify-center tw-gap-2 tw-bg-[#4B6EEC] tw-text-white tw-text-[14px] tw-font-bold tw-leading-[14px] tw-rounded-lg tw-py-[10px] tw-px-[14px]"
                    (click)="onSubmitNewApp()"
                >
                    <mat-icon
                        class="tw-text-[24px] tw-w-[18px] tw-h-[18px] tw-align-middle"
                        >add</mat-icon
                    >
                    {{ "DASHBOARD.DASHBOARD_MAIN.SUBMIT_NEW_APP" | translate }}
                </button>
            </div>
            <!-- Approved Application Section -->
            <div
                *ngIf="approvedApplications?.length"
                class="tw-bg-white tw-border tw-border-gray-200 tw-rounded-[20px] tw-w-full tw-max-w-[347px] tw-px-[14px] tw-py-4 tw-space-y-[14px]"
            >
                <!-- list section -->
                <div
                    *ngFor="
                        let item of approvedApplications
                            | slice : 0 : visibleCountMobile
                    "
                    class="tw-flex tw-items-start tw-gap-3 tw-pt-3 tw-border-b tw-border-gray-200"
                >
                    <div
                        class="tw-rounded-full tw-flex tw-items-center tw-justify-center tw-border tw-border-gray-300 tw-p-1"
                    >
                        <img
                            [src]="item.prodImage"
                            alt="Bank"
                            class="tw-w-[40px] tw-h-[40px] tw-object-contain"
                        />
                    </div>
                    <div class="tw-flex-1">
                        <p class="tw-font-semibold tw-text-sm tw-text-black">
                            {{ item.productName }}
                        </p>

                        <div class="tw-flex tw-gap-6">
                            <!-- Financing Amount -->
                            <div>
                                <p
                                    class="!tw-text-[11px] !tw-font-semibold tw-text-[#7B7575]"
                                >
                                    {{
                                        "FINANCING_STEPS.PRODUCT_FINANCING"
                                            | translate
                                    }}
                                    <br />
                                    {{
                                        item.productValidation?.financeAmount
                                            ?.min
                                            | currency
                                                : "RM "
                                                : "symbol"
                                                : "1.0-0"
                                    }}
                                    -
                                    {{
                                        item.productValidation?.financeAmount
                                            ?.max
                                            | currency
                                                : "RM "
                                                : "symbol"
                                                : "1.0-0"
                                    }}
                                    <br />
                                    <span class="tw-text-gray-400">{{
                                        "NEW_PRODUCTS.STARTS_FROM" | translate
                                    }}</span>
                                </p>
                            </div>

                            <!-- Status -->
                            <div>
                                <p
                                    class="tw-text-xs tw-font-semibold tw-text-black"
                                >
                                    Status
                                </p>
                                <p class="tw-text-xs tw-text-[#0A0A75]">
                                    {{ item.cCaseStatus | translate }}
                                </p>
                            </div>
                        </div>
                        <!-- View Details Button (Mobile) -->
                        <button
                            class="tw-border tw-border-[#003A70] tw-text-[#003A70] tw-text-xs tw-font-semibold tw-rounded-full tw-px-[26px] tw-py-[10px] tw-mb-5"
                            (click)="viewAppDetails(item)"
                        >
                            {{ "COMMON.VIEW_DETAILS" | translate }}
                        </button>
                    </div>
                </div>
            </div>

            <!-- Show More Button(Mobile) -->
            <div
                *ngIf="visibleCountMobile < approvedApplications.length"
                class="tw-text-center"
            >
                <button
                    (click)="onShowMoreMobile()"
                    class="tw-flex tw-items-center tw-justify-center tw-mt-3 tw-w-full tw-bg-[#F5F5F5] tw-text-gray-700 tw-font-medium tw-text-sm tw-py-2 tw-rounded-lg hover:tw-bg-gray-200"
                >
                    {{ "SELECT_BRANCH.SHOW_MORE" | translate }}
                    <mat-icon>expand_more</mat-icon>
                </button>
            </div>

            <!-- Tabs -->
            <div
                class="tw-flex tw-justify-between tw-border-b tw-border-gray-200 tw-mb-4 tw-mt-5"
            >
                <button
                    (click)="onTableTabChange('recent')"
                    [ngClass]="{
                        'tw-text-black tw-font-semibold':
                            activeTableTab === 'recent',
                        'tw-text-gray-500': activeTableTab !== 'recent'
                    }"
                    class="tw-pb-2 tw-text-sm"
                >
                    {{ "COMMON.RECENT" | translate }}
                </button>
                <button
                    *ngIf="activeTab === 'business'"
                    (click)="onTableTabChange('past')"
                    [ngClass]="{
                        'tw-text-black tw-font-semibold':
                            activeTableTab === 'past',
                        'tw-text-gray-500': activeTableTab !== 'past'
                    }"
                    class="tw-pb-2 tw-text-sm"
                >
                    {{ "COMMON.PAST" | translate }}
                </button>
                <button
                    *ngIf="activeTab === 'business'"
                    (click)="onTableTabChange('draft')"
                    [ngClass]="{
                        'tw-text-black tw-font-semibold':
                            activeTableTab === 'draft',
                        'tw-text-gray-500': activeTableTab !== 'draft'
                    }"
                    class="tw-pb-2 tw-text-sm"
                >
                    {{ "COMMON.DRAFT" | translate }}
                </button>
            </div>

            <!-- Dynamic Tabs -->
            <ng-container [ngSwitch]="activeTableTab">
                <app-all-applications-recent
                    *ngSwitchCase="'recent'"
                    [paginatedApplications]="paginatedData"
                    (viewDetailsClicked)="viewAppDetails($event)"
                >
                </app-all-applications-recent>
                <app-all-applications-past
                    *ngSwitchCase="'past'"
                    [pastApplications]="paginatedData"
                    (viewDetailsClicked)="viewAppDetails($event)"
                >
                </app-all-applications-past>
                <app-all-applications-draft
                    *ngSwitchCase="'draft'"
                ></app-all-applications-draft>
            </ng-container>

            <!-- Pagination (Mobile) -->
            <div
                *ngIf="
                    (activeTableTab === 'recent' ||
                        activeTableTab === 'past') &&
                    paginatedData.length > 0
                "
                class="tw-flex tw-justify-center tw-mt-4 tw-gap-1 tw-flex-wrap"
            >
                <!-- Prev -->
                <button
                    class="tw-flex tw-items-center tw-justify-center tw-gap-1 tw-border tw-border-gray-300 tw-rounded tw-px-2 tw-py-1 tw-text-sm"
                    [disabled]="currentPage === 1"
                    (click)="goToPreviousPage()"
                >
                    <mat-icon
                        class="tw-text-[16px] !tw-h-[16px]"
                        style="color: rgba(52, 51, 48, 0.5)"
                        >arrow_back</mat-icon
                    >
                    {{ "DASHBOARD.DASHBOARD_MAIN.PREVIOUS" | translate }}
                </button>

                <!-- Page Numbers -->
                <ng-container *ngFor="let page of mobilePagesToShow">
                    <button
                        *ngIf="page !== '...'; else dots"
                        (click)="goToPage(page)"
                        [ngClass]="{
                            'tw-bg-[#003A70] tw-text-white':
                                currentPage === page,
                            'tw-bg-white tw-text-gray-600 hover:tw-bg-gray-100':
                                currentPage !== page
                        }"
                        class="tw-rounded tw-px-3 tw-py-1 tw-text-sm tw-min-w-[34px]"
                    >
                        {{ page }}
                    </button>
                    <ng-template #dots>
                        <span class="tw-px-2 tw-text-gray-400">...</span>
                    </ng-template>
                </ng-container>

                <!-- Next -->
                <button
                    class="tw-flex tw-items-center tw-justify-center tw-gap-1 tw-border tw-border-gray-300 tw-rounded tw-px-2 tw-py-1 tw-text-sm"
                    [disabled]="currentPage === totalPages"
                    (click)="goToNextPage()"
                >
                    {{ "DASHBOARD.DASHBOARD_MAIN.NEXT" | translate }}
                    <mat-icon
                        class="tw-text-[16px] !tw-h-[16px]"
                        style="color: rgba(52, 51, 48, 0.5)"
                        >arrow_forward</mat-icon
                    >
                </button>
            </div>
        </div>
    </app-dashboard-wrapper>
</div>
<app-loader [showLoader]="!apiResponse"></app-loader>
